import {
    gsap
} from "gsap";
import {
    ScrollTrigger
} from "gsap/ScrollTrigger";
import GLightbox from 'glightbox';
gsap.registerPlugin(ScrollTrigger);


const lightbox = GLightbox({
    touchNavigation: true,
    selector: '.glightbox',
    loop: true,
    autoplayVideos: true
});

const modal = document.getElementById('exampleModal');

if (modal) {

    modal.addEventListener('show.bs.modal', function(event) {
        // event.preventDefault();
        const link = event.relatedTarget.getAttribute('href');
        const modalData = document.querySelector('.modal-body');

        const loader = `<div class="d-flex justify-content-center align-items-center"><div style="width: 2rem; height: 2rem;" class="my-5 spinner-border" role="status"></div></div>`;
        document.querySelector('.modal-body').innerHTML = loader;


        // Post-Slug in URL schreiben
        // history.pushState(null, null, link);

        // fetch(link).then(res => res.text()).then(html => {
        //   modalData.innerHTML = html; 
        // });


        fetch(link).then(function(response) {
            // The API call was successful!
            return response.text();
        }).then(function(html) {

            // Convert the HTML string into a document object
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            // Get the article
            var article = doc.querySelector('article');
            modalData.innerHTML = article.innerHTML;
            // console.log(article);

            lightbox.reload();

        }).catch(function(err) {
            // There was an error
            // console.warn('Something went wrong.', err);
        });

    });

    modal.addEventListener('hidden.bs.modal', function(event) {

        // Post-Slug wieder entfernen
        // history.pushState(null, null, "/");

        // Modal resetten beim Schliessen
        const modalData = document.querySelector('.modal-body');
        modalData.innerHTML = '';

    });

}

// SVG Pan Zoom Start
var eventsHandler;

eventsHandler = {
    haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel']
, init: function(options) {
    var instance = options.instance
        , initialScale = 1
        , pannedX = 0
        , pannedY = 0

    // Init Hammer
    // Listen only for pointer and touch events
    this.hammer = Hammer(options.svgElement, {
        inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
    })

    // Enable pinch
    this.hammer.get('pinch').set({enable: true})

    // Handle double tap
    this.hammer.on('doubletap', function(ev){
        instance.zoomIn()
    })

    // Handle pan
    this.hammer.on('panstart panmove', function(ev){
        // On pan start reset panned variables
        if (ev.type === 'panstart') {
        pannedX = 0
        pannedY = 0
        }

        // Pan only the difference
        instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY})
        pannedX = ev.deltaX
        pannedY = ev.deltaY
    })

    // Handle pinch
    this.hammer.on('pinchstart pinchmove', function(ev){
        // On pinch start remember initial zoom
        if (ev.type === 'pinchstart') {
        initialScale = instance.getZoom()
        instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
        }

        instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
    })

    // Prevent moving the page on some devices when panning over SVG
    options.svgElement.addEventListener('touchmove', function(e){ e.preventDefault(); });
    }

, destroy: function(){
    this.hammer.destroy()
    }
}

function customPanBy(amount){ // {x: 1, y: 2}
    var animationTime = 350 // ms
    , animationStepTime = 15 // one frame per 30 ms
    , animationSteps = animationTime / animationStepTime
    , animationStep = 0
    , intervalID = null
    , destX = (window.innerWidth/2) - amount.x
    , destY = (window.innerHeight/2) - amount.y
    , stepX = destX / animationSteps
    , stepY = destY / animationSteps
    

    intervalID = setInterval(function(){
    if (animationStep++ < animationSteps) {
        panZoom.panBy({x: stepX, y: stepY})
    } else {
        // Cancel interval
        clearInterval(intervalID)
    }
    }, animationStepTime)
}

var buttonHeranwachsen = document.getElementById("heranwachsen-button")
buttonHeranwachsen.addEventListener("click", function() {

    const { left, width, top, height } = buttonHeranwachsen.getBoundingClientRect();
    // customPanBy({x: left + width, y: top});
    // if (buttonHeranwachsen.classList.contains("button-active")) {
    //     customPanBy({x: Math.round(0), y: Math.round(0)});
    // }
    // else {
    //     customPanBy({x: width/2 - left, y: height/2 - top});
    //     buttonHeranwachsen.classList.add("button-active");
    // }
    customPanBy({x: left + width/2, y: top + height/2});

});


var buttonEntdecken = document.getElementById("entdecken-button")
buttonEntdecken.addEventListener("click", function() {

    const { left, width, top, height } = buttonEntdecken.getBoundingClientRect();
    customPanBy({x: left + width/2, y: top + height/2});

});

var buttonFaecherprofil = document.getElementById("faecherprofil-button")
buttonFaecherprofil.addEventListener("click", function() {

    const { left, width, top, height } = buttonFaecherprofil.getBoundingClientRect();
    customPanBy({x: left + width/2, y: top + height/2});

});

var buttonVernetzen = document.getElementById("vernetzen-button")
buttonVernetzen.addEventListener("click", function() {

    const { left, width, top, height } = buttonVernetzen.getBoundingClientRect();
    customPanBy({x: left + width/2, y: top + height/2});

});

var buttonEngagieren = document.getElementById("sich-engagieren-button")
buttonEngagieren.addEventListener("click", function() {

    const { left, width, top, height } = buttonEngagieren.getBoundingClientRect();
    customPanBy({x: left + width/2, y: top + height/2});

});

var buttonSchwerpunkte = document.getElementById("schwerpunkte-button")
buttonSchwerpunkte.addEventListener("click", function() {

    const { left, width, top, height } = buttonSchwerpunkte.getBoundingClientRect();
    customPanBy({x: left + width/2, y: top + height/2});

});


var panZoom = svgPanZoom('#mindmap-container', {
    zoomEnabled: true,
    controlIconsEnabled: false,
    preventMouseEventsDefault: false,
    mouseWheelZoomEnabled: true,
    dblClickZoomEnabled: false,
    fit: 1,
    center: 1,
    customEventsHandler: eventsHandler,
    refreshRate: 40,
    maxZoom: 3
});

    
document.getElementById('zoom-in').addEventListener('click', function(ev) {
    ev.preventDefault();
    panZoom.zoomIn();
});

document.getElementById('zoom-out').addEventListener('click', function(ev) {
    ev.preventDefault();
    panZoom.zoomOut();
});


window.addEventListener('resize', (e) => {
    panZoom.resize();
    panZoom.fit();
    panZoom.center();
});



// GSAP Start
  
const mindMapContainer = document.querySelector("#mindmap");

if(mindMapContainer) {

    gsap.set(".main-item", {
        scale: .6,
        opacity: 0,
        transformOrigin: "center center"
    });
    
    gsap.to("#schwerpunkte-container", {
        delay: .2,
        scale: 1,
        duration: .5,
        opacity: 1,
        ease: "back.out(1.4)"
    });
    gsap.to("#faecherprofil-container", {
        scale: 1,
        duration: .5,
        opacity: 1,
        ease: "back.out(1.4)"
    }, '-=.4') 
    
    gsap.to("#heranwachsen-container", {
        scale: 1,
        duration: .5,
        opacity: 1,
        ease: "back.out(1.4)"
    }, '-=.4')

    gsap.to("#entdecken-container", {
        scale: 1,
        duration: .5,
        opacity: 1,
        ease: "back.out(1.4)"
    }, '-=.4') 

    gsap.to("#vernetzen-container", {
        scale: 1,
        duration: .5,
        opacity: 1,
        ease: "back.out(1.4)"
    }, '-=.4')

    gsap.to("#sich-engagieren-container", {
        scale: 1,
        duration: .5,
        opacity: 1,
        ease: "back.out(1.4)"
    }, '-=.4')
          

}


const categoryContainer = document.querySelectorAll(".category-container");

categoryContainer.forEach((item) => {
    const btnToggle = item.querySelector(".button-main");

    const categoryToggler= item.querySelectorAll(".svg-category-text");

    btnToggle.addEventListener("click", () => {
        tl.reversed() ? tl.play() : tl.reverse();
        if (tl.reversed()) {
            
            categoryToggler.forEach(elem => elem.classList.remove("category-active"));
        } else {
        }
    });

    let items = item.querySelectorAll(".svg-category-item");

    var tl = gsap.timeline({
        paused: true,
        reversed: true
    });

    items.forEach((item, i) => {
        const categoryText = item.querySelectorAll(".svg-category-text");
        const categoryLine = item.querySelectorAll(".svg-category-arrow line");
        const categoryArrow = item.querySelectorAll(".svg-category-arrow polygon");
        let child = gsap.timeline();

        child.set(categoryText, {
            scale: .3,
            opacity: 0,
            transformOrigin: "center center"
        });

        child.to(categoryLine, {
            strokeDashoffset: 0,
            duration: 0.25
        });

        child.to(
            categoryArrow, {
                opacity: 1,
                duration: 0.15,
                ease: "none"
            },
            "-=0.1"
        );


        child.to(
            categoryText, {
                opacity: 1,
                scale: 1,
                duration: 0.3,
                ease: "back.out(1.4)",
                onComplete: function() {
                    this.targets().forEach(elem => elem.classList.add("category-active"));
                }
            },
            "-=0.1"
        );

        tl.add(child, i * 0.2);



       

        
        // gsap breakpoints start
        let mm = gsap.matchMedia();

        // add a media query. When it matches, the associated function will run
        mm.add("(min-width: 991.99px)", () => {

            panZoom.zoom(1);

            document.getElementById('reset').addEventListener('click', function(ev) {
                ev.preventDefault();

                if (!tl.isActive()){
                    tl.reverse();
                }

                panZoom.resetZoom();
                panZoom.center();
                panZoom.zoom(1);
            });    

        });

        mm.add("(max-width: 991.98px)", () => {

            panZoom.zoom(1.3);

            document.getElementById('reset').addEventListener('click', function(ev) {
                ev.preventDefault();

                if (!tl.isActive()){
                    tl.reverse();
                }

                panZoom.resetZoom();
                panZoom.center();
                panZoom.zoom(1.3);
            });

        });
         // gsap breakpoints end


    });







});

// gsap breakpoints start
let mm = gsap.matchMedia();

// add a media query. When it matches, the associated function will run
mm.add("(min-width: 991.99px)", () => {

    panZoom.zoom(1);

    document.getElementById('reset').addEventListener('click', function(ev) {
        ev.preventDefault();

        if (!tlfaecher.isActive()){
            tlfaecher.reverse();
        }
        if (!tlHeranwachsen.isActive()){
            tlHeranwachsen.reverse();
        }
        if (!tlSprachen.isActive()){
            tlSprachen.reverse();
        }
        if (!tlGesell.isActive()){
            tlGesell.reverse();
        }
        if (!tlMint.isActive()){
            tlMint.reverse();
        }
        if (!tlSprachen.isActive()){
            tlSprachen.reverse();
        }
        if (!tlAnkommen.isActive()){
            tlAnkommen.reverse();
        }
        if (!tlJahrgangsstufen.isActive()){
            tlJahrgangsstufen.reverse();
        }

        panZoom.resetZoom();
        panZoom.center();
        panZoom.zoom(1);
    });    

});

mm.add("(max-width: 991.98px)", () => {

    panZoom.zoom(1.3);

    document.getElementById('reset').addEventListener('click', function(ev) {
        ev.preventDefault();

        if (!tlfaecher.isActive()){
            tlfaecher.reverse();
        }
        if (!tlHeranwachsen.isActive()){
            tlHeranwachsen.reverse();
        }
        if (!tlSprachen.isActive()){
            tlSprachen.reverse();
        }
        if (!tlGesell.isActive()){
            tlGesell.reverse();
        }
        if (!tlMint.isActive()){
            tlMint.reverse();
        }
        if (!tlSprachen.isActive()){
            tlSprachen.reverse();
        }
        if (!tlAnkommen.isActive()){
            tlAnkommen.reverse();
        }
        if (!tlJahrgangsstufen.isActive()){
            tlJahrgangsstufen.reverse();
        }

        panZoom.resetZoom();
        panZoom.center();
        panZoom.zoom(1.3);
    });

});
// gsap breakpoints end

mm.add("(max-height: 460px)", () => {

    panZoom.zoom(.8);

    document.getElementById('reset').addEventListener('click', function(ev) {
        ev.preventDefault();

        if (!tlfaecher.isActive()){
            tlfaecher.reverse();
        }
        if (!tlHeranwachsen.isActive()){
            tlHeranwachsen.reverse();
        }
        if (!tlSprachen.isActive()){
            tlSprachen.reverse();
        }
        if (!tlGesell.isActive()){
            tlGesell.reverse();
        }
        if (!tlMint.isActive()){
            tlMint.reverse();
        }
        if (!tlSprachen.isActive()){
            tlSprachen.reverse();
        }
        if (!tlAnkommen.isActive()){
            tlAnkommen.reverse();
        }
        if (!tlJahrgangsstufen.isActive()){
            tlJahrgangsstufen.reverse();
        }

        panZoom.resetZoom();
        panZoom.center();
        panZoom.zoom(.8);
    });

});







// Faecherprofil Timeline

const btnToggleFaecher = document.querySelector("#faecherprofil-container .button-main");

const categoryFaecherToggler= document.querySelectorAll("#faecherprofil-container .svg-category-text");

let faecherItems = document.querySelectorAll("#faecherprofil-container .svg-category-item");

var tlfaecher = gsap.timeline({
    paused: true,
    reversed: true
});

btnToggleFaecher.addEventListener("click", () => {
    tlfaecher.reversed() ? tlfaecher.play() : tlfaecher.reverse();
    if (tlfaecher.reversed()) {
        categoryFaecherToggler.forEach(elem => elem.classList.remove("category-active"));
        tlMint.reverse();
        tlSprachen.reverse();
        tlGesell.reverse();
    } else {
    }
});

faecherItems.forEach((item, i) => {
    const categoryFaecherText = item.querySelectorAll(".svg-category-text");
    const categoryFaecherLine = item.querySelectorAll(".svg-category-arrow line");
    const categoryFaecherArrow = item.querySelectorAll(".svg-category-arrow polygon");
    let child = gsap.timeline();

    child.set(categoryFaecherText, {
        scale: .3,
        opacity: 0,
        transformOrigin: "center center"
    });

    child.to(categoryFaecherLine, {
        strokeDashoffset: 0,
        duration: 0.25
    });

    child.to(
        categoryFaecherArrow, {
            opacity: 1,
            duration: 0.15,
            ease: "none"
        },
        "-=0.1"
    );


    child.to(
        categoryFaecherText, {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: "back.out(1.4)",
            onComplete: function() {
                this.targets().forEach(elem => elem.classList.add("category-active"));
            }
        },
        "-=0.1"
    );

    tlfaecher.add(child, i * 0.2);

});


// Faecherprofil MINT
let mintItems = document.querySelectorAll("#faecherprofil-mint .svg-subcategory-item");
const btnToggleMint = document.querySelector("#faecherprofil-mint .button-subcategory");

var tlMint = gsap.timeline({
    paused: true,
    reversed: true
});

btnToggleMint.addEventListener("click", () => {
    tlMint.reversed() ? tlMint.play() : tlMint.reverse();
});

mintItems.forEach((item, i) => {
    const categoryMintText = item.querySelectorAll(".svg-subcategory-text");
    const categoryMintLine = item.querySelectorAll(".svg-subcategory-arrow line");
    const categoryMintArrow = item.querySelectorAll(".svg-subcategory-arrow polygon");
    let child = gsap.timeline();

    child.set(categoryMintText, {
        scale: .3,
        opacity: 0,
        transformOrigin: "center center"
    });

    child.to(categoryMintLine, {
        strokeDashoffset: 0,
        duration: 0.25
    });

    child.to(
        categoryMintArrow, {
            opacity: 1,
            duration: 0.15,
            ease: "none"
        },
        "-=0.1"
    );


    child.to(
        categoryMintText, {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: "back.out(1.4)",
            onComplete: function() {
                this.targets().forEach(elem => elem.classList.add("category-active"));
            }
        },
        "-=0.1"
    );

    tlMint.add(child, i * 0.2);

});

// Faecherprofil Sprachen
let sprachenItems = document.querySelectorAll("#faecherprofil-sprachen .svg-subcategory-item");
const btnToggleSprachen = document.querySelector("#faecherprofil-sprachen .button-subcategory");

var tlSprachen = gsap.timeline({
    paused: true,
    reversed: true
});

btnToggleSprachen.addEventListener("click", () => {
    tlSprachen.reversed() ? tlSprachen.play() : tlSprachen.reverse();
});

sprachenItems.forEach((item, i) => {
    const categorySprachenText = item.querySelectorAll(".svg-subcategory-text");
    const categorySprachenLine = item.querySelectorAll(".svg-subcategory-arrow line");
    const categorySprachenArrow = item.querySelectorAll(".svg-subcategory-arrow polygon");
    let child = gsap.timeline();

    child.set(categorySprachenText, {
        scale: .3,
        opacity: 0,
        transformOrigin: "center center"
    });

    child.to(categorySprachenLine, {
        strokeDashoffset: 0,
        duration: 0.25
    });

    child.to(
        categorySprachenArrow, {
            opacity: 1,
            duration: 0.15,
            ease: "none"
        },
        "-=0.1"
    );


    child.to(
        categorySprachenText, {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: "back.out(1.4)",
            onComplete: function() {
                this.targets().forEach(elem => elem.classList.add("category-active"));
            }
        },
        "-=0.1"
    );

    tlSprachen.add(child, i * 0.2);

});


// Gesellschafts Timeline
let gesellItems = document.querySelectorAll("#faecherprofil-gesellschafts .svg-subcategory-item");
const btnToggleGesell = document.querySelector("#faecherprofil-gesellschafts .button-subcategory");

var tlGesell = gsap.timeline({
    paused: true,
    reversed: true
});

btnToggleGesell.addEventListener("click", () => {
    tlGesell.reversed() ? tlGesell.play() : tlGesell.reverse();
});

gesellItems.forEach((item, i) => {
    const categoryGesellText = item.querySelectorAll(".svg-subcategory-text");
    const categoryGesellLine = item.querySelectorAll(".svg-subcategory-arrow line");
    const categoryGesellArrow = item.querySelectorAll(".svg-subcategory-arrow polygon");
    let child = gsap.timeline();

    child.set(categoryGesellText, {
        scale: .3,
        opacity: 0,
        transformOrigin: "center center"
    });

    child.to(categoryGesellLine, {
        strokeDashoffset: 0,
        duration: 0.25
    });

    child.to(
        categoryGesellArrow, {
            opacity: 1,
            duration: 0.15,
            ease: "none"
        },
        "-=0.1"
    );


    child.to(
        categoryGesellText, {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: "back.out(1.4)",
            onComplete: function() {
                this.targets().forEach(elem => elem.classList.add("category-active"));
            }
        },
        "-=0.1"
    );

    tlGesell.add(child, i * 0.2);

});





// Heranwachsen Timeline

const btnToggleHeranwachsen = document.querySelector("#heranwachsen-container .button-main");

const categoryHeranwachsenToggler= document.querySelectorAll("#heranwachsen-container .svg-category-text");

let heranwachsenItems = document.querySelectorAll("#heranwachsen-container .svg-category-item");

var tlHeranwachsen = gsap.timeline({
    paused: true,
    reversed: true
});

btnToggleHeranwachsen.addEventListener("click", () => {
    tlHeranwachsen.reversed() ? tlHeranwachsen.play() : tlHeranwachsen.reverse();
    if (tlHeranwachsen.reversed()) {
        categoryHeranwachsenToggler.forEach(elem => elem.classList.remove("category-active"));
        tlAnkommen.reverse();
        tlJahrgangsstufen.reverse();
    } else {
    }
});


heranwachsenItems.forEach((item, i) => {
    const categoryHeranwachsenText = item.querySelectorAll(".svg-category-text");
    const categoryHeranwachsenLine = item.querySelectorAll(".svg-category-arrow line");
    const categoryHeranwachsenArrow = item.querySelectorAll(".svg-category-arrow polygon");
    let child = gsap.timeline();

    child.set(categoryHeranwachsenText, {
        scale: .3,
        opacity: 0,
        transformOrigin: "center center"
    });

    child.to(categoryHeranwachsenLine, {
        strokeDashoffset: 0,
        duration: 0.25
    });

    child.to(
        categoryHeranwachsenArrow, {
            opacity: 1,
            duration: 0.15,
            ease: "none"
        },
        "-=0.1"
    );


    child.to(
        categoryHeranwachsenText, {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: "back.out(1.4)",
            onComplete: function() {
                this.targets().forEach(elem => elem.classList.add("category-active"));
            }
        },
        "-=0.1"
    );

    tlHeranwachsen.add(child, i * 0.2);

});



let ankommenItems = document.querySelectorAll("#heranwachsen-ankommen .svg-subcategory-item");
const btnToggleankommen = document.querySelector("#heranwachsen-ankommen .button-subcategory");

var tlAnkommen = gsap.timeline({
    paused: true,
    reversed: true
});

btnToggleankommen.addEventListener("click", () => {
    tlAnkommen.reversed() ? tlAnkommen.play() : tlAnkommen.reverse();
});

ankommenItems.forEach((item, i) => {
    const categoryAnkommenText = item.querySelectorAll(".svg-subcategory-text");
    const categoryAnkommenLine = item.querySelectorAll(".svg-subcategory-arrow line");
    const categoryAnkommenArrow = item.querySelectorAll(".svg-subcategory-arrow polygon");
    let child = gsap.timeline();

    child.set(categoryAnkommenText, {
        scale: .3,
        opacity: 0,
        transformOrigin: "center center"
    });

    child.to(categoryAnkommenLine, {
        strokeDashoffset: 0,
        duration: 0.25
    });

    child.to(
        categoryAnkommenArrow, {
            opacity: 1,
            duration: 0.15,
            ease: "none"
        },
        "-=0.1"
    );


    child.to(
        categoryAnkommenText, {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: "back.out(1.4)",
            onComplete: function() {
                this.targets().forEach(elem => elem.classList.add("category-active"));
            }
        },
        "-=0.1"
    );

    tlAnkommen.add(child, i * 0.2);

});



let jahrgangsstufenItems = document.querySelectorAll("#heranwachsen-jahrgangsstufen .svg-subcategory-item");
const btnToggleJahrgangsstufen = document.querySelector("#heranwachsen-jahrgangsstufen .button-subcategory");

var tlJahrgangsstufen = gsap.timeline({
    paused: true,
    reversed: true
});

btnToggleJahrgangsstufen.addEventListener("click", () => {
    tlJahrgangsstufen.reversed() ? tlJahrgangsstufen.play() : tlJahrgangsstufen.reverse();
});

jahrgangsstufenItems.forEach((item, i) => {
    const categoryJahrgangsstufenText = item.querySelectorAll(".svg-subcategory-text");
    const categoryJahrgangsstufenLine = item.querySelectorAll(".svg-subcategory-arrow line");
    const categoryJahrgangsstufenArrow = item.querySelectorAll(".svg-subcategory-arrow polygon");
    let child = gsap.timeline();

    child.set(categoryJahrgangsstufenText, {
        scale: .3,
        opacity: 0,
        transformOrigin: "center center"
    });

    child.to(categoryJahrgangsstufenLine, {
        strokeDashoffset: 0,
        duration: 0.25
    });

    child.to(
        categoryJahrgangsstufenArrow, {
            opacity: 1,
            duration: 0.15,
            ease: "none"
        },
        "-=0.1"
    );


    child.to(
        categoryJahrgangsstufenText, {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: "back.out(1.4)",
            onComplete: function() {
                this.targets().forEach(elem => elem.classList.add("category-active"));
            }
        },
        "-=0.1"
    );

    tlJahrgangsstufen.add(child, i * 0.2);

});